import {Route, Routes} from 'react-router-dom';
import {authRoutes} from '../../routing/routes';
import AuthLayout from './common/components/AuthLayout';
import Forgot from './pages/forgot/Forgot';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import Reset from './pages/reset/Reset';
import VerifyForgot from './pages/verify-forgot/VerifyForgot';

const AuthRoutes = () => (
	<Routes>
		<Route element={<AuthLayout />}>
			<Route path={authRoutes.login} element={<Login />} />
			<Route path={authRoutes.forgot} element={<Forgot />} />
			<Route path={authRoutes.verifyForgot} element={<VerifyForgot />} />
			<Route path={authRoutes.reset} element={<Reset />} />
			<Route path={authRoutes.register} element={<Register />} />
			<Route index element={<Login />} />
		</Route>
	</Routes>
);

export {AuthRoutes};
